import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// App-shell cache for the offline POS. Also hands the SW everything this page already loaded (bundles, fonts, logo).
if ("serviceWorker" in navigator && window.isSecureContext) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
    navigator.serviceWorker.ready.then((reg) => {
      const urls = performance
        .getEntriesByType("resource")
        .map((r) => r.name)
        .filter((u) => !u.includes("/api/") && !u.includes("hot-update") && (u.startsWith(window.location.origin) || /fonts\.(googleapis|gstatic)\.com/.test(u)));
      reg.active?.postMessage({ type: "cache-urls", urls: ["/", ...new Set(urls)] });
    });
  });
}
